import React from 'react';
import '../Styles/styles.css';
import { Link } from 'react-router-dom';

const CaseStudies = () => {
    return (
        <section id="casestudies" className="services section-bg">
            <div className="container" data-aos="fade-up">

                <div className="section-title">
                    <h2>Case Studies</h2>
                </div>

                <div className="row">
                    <div className="col-xl-3 col-md-6 d-flex align-items-stretch" data-aos="zoom-in" data-aos-delay="100">
                        <div className="card card-case" style={{ width: "18rem;" }}>
                            <img src="https://www.mmcspl.com/img/Digital-office.jpg" className="card-img-top" alt="..." />
                            <div className="card-body">
                                <h5 className="card-title card-case-title">Digital Office Framework</h5>
                                <p className="card-text">
                                    Modern office work involves managing of compound documents - paper documents,
                                    scanned images, word and excel files, Emails, Drawings and Sketches, video
                                    clippings, and many more. Defining workflows, processing, archiving and
                                    retrieving documents when needed.
                                </p>
                                <Link to='/digital-office-framework' className="text-decoration-none">
                                    Read more <i className="bi bi-arrow-right"></i>
                                </Link>
                            </div>
                        </div>
                    </div>

                    <div className="col-xl-3 col-md-6 d-flex align-items-stretch mt-4 mt-md-0" data-aos="zoom-in" data-aos-delay="200">
                        <div className="card card-case" style={{ width: "18rem;" }}>
                            <img src="https://www.mmcspl.com/img/Governance-Risk-and-Compliance.jpg" className="card-img-top" alt="..." />
                            <div className="card-body">
                                <h5 className="card-title card-case-title">TRACe GRC</h5>
                                <p className="card-text">
                                    TRACe is an auditor's Workbench based on ISO standards. By using TRACe, auditor’s
                                    are automatically complying with the standard Plan-Do-Check-Act methodology.
                                    TRACe is designed to be flexible to enable auditor’s to define, plan and execute
                                    audits that cover different domains.
                                </p>
                                <Link to='/trace-grc' className="text-decoration-none">
                                    Read more <i className="bi bi-arrow-right"></i>
                                </Link>
                            </div>
                        </div>
                    </div>

                    <div className="col-xl-3 col-md-6 d-flex align-items-stretch mt-4 mt-xl-0" data-aos="zoom-in" data-aos-delay="300">
                        <div className="card card-case" style={{ width: "18rem;" }}>
                            <img src="https://www.mmcspl.com/img/Financial-accounting.jpg" className="card-img-top" alt="..." />
                            <div className="card-body">
                                <h5 className="card-title card-case-title">Financial Accounting</h5>
                                <p className="card-text">
                                    Responsible for design, development and implementation of solution. The design team
                                    interacted with end users to understand and document the business process and workflow.
                                    It also interfaced with large front office management that managed case sales and order
                                    processing.
                                </p>
                                <Link to='/finanacial-accountant' className="text-decoration-none">
                                    Read more <i className="bi bi-arrow-right"></i>
                                </Link>
                            </div>
                        </div>
                    </div>

                    <div className="col-xl-3 col-md-6 d-flex align-items-stretch mt-4 mt-xl-0" data-aos="zoom-in" data-aos-delay="400">
                        <div className="card card-case" style={{ width: "18rem;" }}>
                            <img src="https://www.mmcspl.com/img/Doc-Assist.jpg" className="card-img-top" alt="..." />
                            <div className="card-body">
                                <h5 className="card-title card-case-title">Doc Assist</h5>
                                <p className="card-text">
                                    Various modules developed address various aspects of medical practice such as
                                    patient administration, billing and most importantly modules that enabled doctor
                                    to create patients medical file using templates. This allow doctors to interact
                                    with the patients and provide better care.
                                </p>
                                <Link to='/doc-assist' className="text-decoration-none">
                                    Read more <i className="bi bi-arrow-right"></i>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default CaseStudies